export default {"src":"https://s.sylndr.me/c-a7be377/_next/static/media/checkBoxCheck.784fa5f2.svg","height":8,"width":10,"blurWidth":0,"blurHeight":0};